/**
 * Checks if an element is visible in the DOM.
 *
 * @param {HTMLElement} element - The element to check visibility for.
 * @returns {boolean} - Returns true if the element is visible, otherwise false.
 */
function isVisible(element) {
	return element.offsetParent !== null;
}

/**
 * Scrolls to an element specified by the selector if it exists and is visible.
 * @module scroll into view
 * @param {string} selector - The CSS selector of the element to scroll to.
 */
export default function scrollIntoView(selector) {
	const elements = document.querySelectorAll(selector);
	for (const element of elements) {
		setTimeout(() => {
			if (element && isVisible(element)) {
				element.scrollIntoView({
					behavior: 'smooth', // Changed to 'smooth' for a better user experience
					block: 'center',
					inline: 'center'
				});
			}
		}, 1000);
	}
}
